function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_236",
  "data-name": "Group 236"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_235",
  "data-name": "Group 235"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_117",
  "data-name": "Path 117",
  className: "cls-1",
  d: "M50.468,0H35.312a3.191,3.191,0,1,0,0,6.382h8.251L34.344,15.6a21.3,21.3,0,0,0-12.806-4.22A21.538,21.538,0,1,0,43.076,32.918a21.3,21.3,0,0,0-4.22-12.806l9.219-9.219v8.251a3.191,3.191,0,1,0,6.382,0V3.989A3.993,3.993,0,0,0,50.468,0Zm2.393,19.145a1.6,1.6,0,1,1-3.191,0V8.968A.8.8,0,0,0,48.308,8.4L37.234,19.479a.8.8,0,0,0-.061,1.06,19.732,19.732,0,0,1,4.308,12.38A19.943,19.943,0,1,1,21.538,12.976a19.733,19.733,0,0,1,12.38,4.308.8.8,0,0,0,1.06-.061L46.052,6.148a.8.8,0,0,0-.564-1.362H35.312a1.6,1.6,0,0,1,0-3.191H50.468a2.4,2.4,0,0,1,2.393,2.393Z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_238",
  "data-name": "Group 238",
  transform: "translate(4.796 16.09)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_237",
  "data-name": "Group 237"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_118",
  "data-name": "Path 118",
  className: "cls-1",
  d: "M61.785,152a16.817,16.817,0,0,0-10.623,3.789.8.8,0,1,0,1.012,1.237,15.187,15.187,0,1,1-2.148,2.148.8.8,0,1,0-1.237-1.012,16.785,16.785,0,1,0,13-6.162Z",
  transform: "translate(-45 -152)"
})));

var SvgMale = function SvgMale(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0427\\u043E\\u043B\\u043E\\u0432\\u0456\\u0447\\u0456",
    width: 54.456,
    height: 54.456,
    viewBox: "0 0 54.456 54.456",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMale, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/male.4e5f9998.svg";
export { ForwardRef as ReactComponent };